import _taggedTemplateLiteral from "/Users/diego.sampaio/olx/connecting/chat-frontend/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import styled from 'styled-components';
typeof window !== 'undefined' && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = '2.10.0');
import { withFlex, withMargins, withPaddings } from '../../mixins';
/**
 * Componente utilitário Flex.
 *
 * Facilita a aplicação de containers flex na aplicação.
 */
export const Flex = styled.div.attrs(_ref => {
  let {
    'data-ds-component': customDataDsComponent
  } = _ref;
  return {
    'data-ds-component': customDataDsComponent !== null && customDataDsComponent !== void 0 ? customDataDsComponent : 'DS-Flex'
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n"])), withFlex, withMargins, withPaddings);